const formatData = (data, formatter) => {
  if (formatter) {
    return formatter(data);
  }
  return data;
};
export {
  formatData
};
